import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { IconTooltip } from 'mdlkit';

interface Props {
  tooltipImage: string;
}

const StyledImg = styled.img`
  width: 100%;
`;

const MemberIdTooltip: FunctionComponent<Props> = ({
  tooltipImage,
  ...rest
}: Props) => (
  <IconTooltip
    size={20}
    width={350}
    position="right"
    ariaLabel="Insurance Member ID information"
    {...rest}
  >
    <StyledImg src={tooltipImage} alt="Insurance Member ID tooltip" />
  </IconTooltip>
);

// @ts-ignore
MemberIdTooltip.isIcon = true;

export default MemberIdTooltip;
